/** P3 매도 유형/종목/보유기간 분해 테이블. */
import {
  HoldPeriodRow,
  SymbolRow,
  TradeTypeRow,
} from '../../services/lossStructureApi';

const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

interface Props {
  byTradeType: TradeTypeRow[];
  bySymbol: SymbolRow[];
  holdPeriod: HoldPeriodRow[];
}

export default function LossBreakdownTables({ byTradeType, bySymbol, holdPeriod }: Props) {
  return (
    <div className="loss-breakdown-grid">
      <section className="loss-section">
        <h3>매도 유형별 손익</h3>
        <table className="loss-table">
          <thead>
            <tr><th>유형</th><th>건수</th><th>평균 %</th><th>합계 $</th><th>최저</th><th>최고</th></tr>
          </thead>
          <tbody>
            {byTradeType.map((r) => (
              <tr key={r.trade_type}>
                <td>{r.trade_type}</td>
                <td>{r.count}</td>
                <td className={toneClass(r.avg_percent)}>{r.avg_percent.toFixed(2)}%</td>
                <td className={toneClass(r.sum_amount)}>{money.format(r.sum_amount)}</td>
                <td>{r.min_percent.toFixed(2)}%</td>
                <td>{r.max_percent.toFixed(2)}%</td>
              </tr>
            ))}
            {byTradeType.length === 0 && (
              <tr><td colSpan={6} className="loss-empty">완료 거래 없음</td></tr>
            )}
          </tbody>
        </table>
      </section>

      <section className="loss-section">
        <h3>보유 기간 패턴 (일)</h3>
        <table className="loss-table">
          <thead>
            <tr><th>유형</th><th>건수</th><th>평균</th><th>최소</th><th>최대</th></tr>
          </thead>
          <tbody>
            {holdPeriod.map((r) => (
              <tr key={r.trade_type}>
                <td>{r.trade_type}</td>
                <td>{r.count}</td>
                <td>{r.avg_days.toFixed(1)}</td>
                <td>{r.min_days.toFixed(1)}</td>
                <td>{r.max_days.toFixed(1)}</td>
              </tr>
            ))}
            {holdPeriod.length === 0 && (
              <tr><td colSpan={5} className="loss-empty">BUY 매칭 데이터 없음</td></tr>
            )}
          </tbody>
        </table>
      </section>

      <section className="loss-section loss-section-wide">
        <h3>종목별 손익 (오름차순)</h3>
        <table className="loss-table">
          <thead>
            <tr><th>종목</th><th>거래</th><th>합계 $</th><th>평균 %</th><th>재진입 위험</th></tr>
          </thead>
          <tbody>
            {bySymbol.slice(0, 15).map((r) => (
              <tr key={r.symbol}>
                <td>{r.symbol}</td>
                <td>{r.count}</td>
                <td className={toneClass(r.sum_amount)}>{money.format(r.sum_amount)}</td>
                <td className={toneClass(r.avg_percent)}>{r.avg_percent.toFixed(2)}%</td>
                <td>{r.has_loss_history ? '⚠️ 손실 이력' : '—'}</td>
              </tr>
            ))}
            {bySymbol.length === 0 && (
              <tr><td colSpan={5} className="loss-empty">완료 거래 없음</td></tr>
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
}

function toneClass(value: number): string {
  if (value > 0) return 'loss-cell-good';
  if (value < 0) return 'loss-cell-bad';
  return '';
}
